import { useQuery } from 'react-query';
import { getRestaurantsList } from './api';
import { RestaurantDetailPayload } from './types';

const useRestaurantList = (payload: RestaurantDetailPayload) => {
  return useQuery(['getRestaurantsList', payload], () => getRestaurantsList(payload));
};

export default useRestaurantList;
